// extracted by mini-css-extract-plugin
module.exports = {"selectArea":"Select_selectArea__3vRv-","active":"Select_active__1XOkH"};